module.exports = __webpack_public_path__ + "fonts/ProximaNovaACond-Extrabld.77942ef9c33e0e08a593ffbd8a35273e.woff";